import {
  useQueryStates,
  parseAsArrayOf,
  parseAsInteger,
  parseAsStringLiteral,
} from 'nuqs'
import { INDEED_FLEX_SHIFT_ISSUE_VALUES } from '../constants/shiftIssues'

export const INDEED_FLEX_ISSUES_DEFAULT_DAYS_AGO = 14

export const useIndeedFlexIssuesFiltersQueryState = () => {
  return useQueryStates(
    {
      ifClientIds: parseAsArrayOf(parseAsInteger),
      companyIds: parseAsArrayOf(parseAsInteger),
      issues: parseAsArrayOf(
        parseAsStringLiteral(INDEED_FLEX_SHIFT_ISSUE_VALUES)
      ),
      daysAgo: parseAsInteger.withDefault(INDEED_FLEX_ISSUES_DEFAULT_DAYS_AGO),
    },
    {
      urlKeys: {
        ifClientIds: 'if-client-ids',
        companyIds: 'company-ids',
        issues: 'issues',
        daysAgo: 'days-ago',
      },
    }
  )
}
